module.exports = __webpack_public_path__ + "static/media/02B.7e3b4a3b.png";